import HomeScreenMain from "./home_screen/HomeScreenMain";
import ExploreAppsMain from "./explore_apps/ExploreAppsMain";
import CompressPDFMain from "./compress_pdf/CompressPDFMain";
import MergePDFMain from "./merge_pdf/MergePDFMain";
import SplitPDFMain from "./split_pdf/SplitPDFMain";
import Pdf2ImageMain from "./pdf_jpg/Pdf2ImageMain";
import Image2PdfMain from "./jpg_pdf/Image2PdfMain";
import LockPDFMain from "./lock_pdf/LockPDFMain";
import UnlockPDFMain from "./unlock_pdf/UnlockPDFMain";
import WatermarkPDFMain from "./watermark_pdf/WatermarkPDFMain";
import PdfUnder200KBMain from "./pdf_under_200_kb/PdfUnder200KBMain";
import ResizePDFMain from "./resize_pdf/ResizePDFMain";
import GrayscalePDFMain from "./grayscale_pdf/GrayscalePDFMain";
import PDFMetadataEditorMain from "./pdf_metadata_editor/PDFMetadataEditorMain";
import FlattenPDFMain from "./flatten_pdf/FlattenPDFMain";
import ExtractPDFPagesMain from "./extract_pdf_pages/ExtractPDFPagesMain";
import EditPDFMain from "./edit_pdf/EditPDFMain";
import DeletePDFPagesMain from "./delete_pdf_pages/DeletePDFPagesMain";
import RearrangePDFMain from "./rearrange_pdf/RearrangePDFMain";
import RotatePDFMain from "./rotate_pdf/RotatePDFMain";
import AddBlankPagesToPDFMain from "./add_blank_pages/AddBlankPagesToPDFMain";
import DocScannerMain from "./doc_scanner/DocScannerMain";
import NumberPDFPagesMain from "./numper_pdf_pages/NumberPDFPagesMain";
import PDFNUpToolMain from "./pdf_n_up_tool/PDFNUpToolMain";
import HTMLToPdfMain from "./html_to_pdf/HTMLToPdfMain";
import PDFViewerMain from "./pdf_viewer/PDFViewerMain";
import CropPDFMain from "./crop_pdf/CropPDFMain";
import CompressFilesMain from "./compress_files/CompressFilesMain";
import ImageConverterMain from "./image_converter/ImageConverterMain";
import QRCodeReaderMain from "./qr_code_reader/QRCodeReaderMain";
import QRCodeGeneratorMain from "./qr_code_generator/QRCodeGeneratorMain";
import PageNotFound from "./PageNotFound";
import PrivacyPolicyMain from "./privacy_tos/PrivacyPolicyMain";
import TermsOfServiceMain from "./privacy_tos/TermsOfServiceMain";
import PDFConverterMain from "./pdf_converter/PDFConverterMain";
import PDFOCRMain from "./pdf_ocr/PDFOCRMain";
import PPTToPDFMain from "./ppt_to_pdf/PPTToPDFMain";
import PDFToPPTMain from "./pdf_to_ppt/PDFToPPTMain";
import ExcelToPDFMain from "./excel_to_pdf/ExcelToPDFMain";
import PDFToExcelMain from "./pdf_to_excel/PDFToExcelMain";
import WordToPDFMain from "./word_to_pdf/WordToPDFMain";
import PDFToWordMain from "./pdf_to_word/PDFToWordMain";
import PDFAnnotatorMain from "./pdf_annotator/PDFAnnotatorMain";
import ImageResizerMain from "./image_resizer/ImageResizerMain";
import { createBrowserRouter } from "react-router";
import WatermarkImageMain from "./watermark_image/WatermarkImageMain";
import MergeImagesMain from "./merge_images/MergeImagesMain";
import SplitImagesMain from "./split_images/SplitImagesMain";
import FlipImagesMain from "./flip_images/FlipImagesMain";
import CropImagesMain from "./crop_images/CropImagesMain";
import HTMLToImageMain from "./html_to_image/HTMLToImageMain";
import RepairPDFMain from "./repair_pdf/RepairPDFMain";
import UpscaleImageMain from "./upscale_image/UpscaleImageMain";

//Router
export const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeScreenMain />,
  },
  {
    path: "/explore_apps",
    element: <ExploreAppsMain />,
  },
  {
    path: "/compress_pdf",
    element: <CompressPDFMain />,
  },
  {
    path: "/compress_pdf_under_200_kb",
    element: <PdfUnder200KBMain />,
  },
  {
    path: "/merge_pdf",
    element: <MergePDFMain />,
  },
  {
    path: "/split_pdf",
    element: <SplitPDFMain />,
  },
  {
    path: "/pdf_to_image",
    element: <Pdf2ImageMain />,
  },
  {
    path: "/image_to_pdf",
    element: <Image2PdfMain />,
  },
  {
    path: "/lock_pdf",
    element: <LockPDFMain />,
  },
  {
    path: "/unlock_pdf",
    element: <UnlockPDFMain />,
  },
  {
    path: "/watermark_pdf",
    element: <WatermarkPDFMain />,
  },
  {
    path: "/resize_pdf",
    element: <ResizePDFMain />,
  },
  {
    path: "/grayscale_pdf",
    element: <GrayscalePDFMain />,
  },
  {
    path: "/pdf_metadata_editor",
    element: <PDFMetadataEditorMain />,
  },
  {
    path: "/flatten_pdf",
    element: <FlattenPDFMain />,
  },
  {
    path: "/extract_pdf_pages",
    element: <ExtractPDFPagesMain />,
  },
  {
    path: "/pdf_editor",
    element: <EditPDFMain />,
  },
  {
    path: "/delete_pdf_pages",
    element: <DeletePDFPagesMain />,
  },
  {
    path: "/rearrange_pdf",
    element: <RearrangePDFMain />,
  },
  {
    path: "/rotate_pdf",
    element: <RotatePDFMain />,
  },
  {
    path: "/add_pages_pdf",
    element: <AddBlankPagesToPDFMain />,
  },
  {
    path: "/document_scanner",
    element: <DocScannerMain />,
  },
  {
    path: "/number_pdf_pages",
    element: <NumberPDFPagesMain />,
  },
  {
    path: "/pdf_n_up_tool",
    element: <PDFNUpToolMain />,
  },
  {
    path: "/html_to_pdf",
    element: <HTMLToPdfMain />,
  },
  {
    path: "/pdf_viewer",
    element: <PDFViewerMain />,
  },
  {
    path: "/crop_pdf",
    element: <CropPDFMain />,
  },
  {
    path: "/compress_files",
    element: <CompressFilesMain />,
  },
  {
    path: "/image_converter",
    element: <ImageConverterMain />,
  },
  {
    path: "/qr_scanner",
    element: <QRCodeReaderMain />,
  },
  {
    path: "/qr_generator",
    element: <QRCodeGeneratorMain />,
  },
  {
    path: "/pdf_converter",
    element: <PDFConverterMain />,
  },
  {
    path: "/pdf_ocr",
    element: <PDFOCRMain />,
  },
  {
    path: "/ppt_to_pdf",
    element: <PPTToPDFMain />,
  },
  {
    path: "/pdf_to_ppt",
    element: <PDFToPPTMain />,
  },
  {
    path: "/excel_to_pdf",
    element: <ExcelToPDFMain />,
  },
  {
    path: "/pdf_to_excel",
    element: <PDFToExcelMain />,
  },
  {
    path: "/word_to_pdf",
    element: <WordToPDFMain />,
  },
  {
    path: "/pdf_to_word",
    element: <PDFToWordMain />,
  },
  {
    path: "/pdf_annotator",
    element: <PDFAnnotatorMain />,
  },
  {
    path: "/image_resizer",
    element: <ImageResizerMain />,
  },
  {
    path: "/merge_images",
    element: <MergeImagesMain />,
  },
  {
    path: "/split_image",
    element: <SplitImagesMain />,
  },
  {
    path: "/watermark_image",
    element: <WatermarkImageMain />,
  },
  {
    path: "/flip_image",
    element: <FlipImagesMain />,
  },
  {
    path: "/crop_image",
    element: <CropImagesMain />,
  },
  {
    path: "/html_to_image",
    element: <HTMLToImageMain />,
  },
  {
    path: "/repair_pdf",
    element: <RepairPDFMain />,
  },
  {
    path: "/upscale_image",
    element: <UpscaleImageMain />,
  },
  {
    //privacy policy
    path: "/privacy_policy",
    element: <PrivacyPolicyMain />,
  },
  {
    //terms_of_service
    path: "/terms_of_service",
    element: <TermsOfServiceMain />,
  },
  {
    //404 routes
    path: "/*",
    element: <PageNotFound />,
  },
]);

export default router;
